import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const updateMaterialOrderStatus = createAsyncThunk(
  '/UpdateMaterialOrderStatus',
  async (req) => {
    const response = await axios.post('/UpdateMaterialOrderStatusByMaterialOrderId', req);
    return response.data;
  }
);

const sparePartOrderManagementSlice = createSlice({
  name: 'sparePartOrderManagement',
  initialState: {
    loading: false,
    error: ''
  },
  reducers: {
  },
  extraReducers: {
    [updateMaterialOrderStatus.pending]: (state) => {
      state.loading = true;
    },
    [updateMaterialOrderStatus.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [updateMaterialOrderStatus.fulfilled]: (state, action) => {
      state.loading = false;
    }
  }
});

export const sparePartOrderManagementActions = sparePartOrderManagementSlice.actions;

export default sparePartOrderManagementSlice;
